import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'access',
})
export default class extends Vue {
  // Повний доступ до функціоналу порталу.
  // false — для незалогованих і для залогованих аплікантів (див. UserModule.hasFullAccess).
  get hasFullAccess(): boolean {
    return UserModule.hasFullAccess;
  }
}
